import { createSelector } from "reselect";
import _ from "lodash";
export const selectCurrentTab = ({ SecurityConfig_reducer }) => {
    return SecurityConfig_reducer.tab;
};
export const selectCurrentUserTab = ({ SecurityConfig_reducer }) => {
    return SecurityConfig_reducer.userTab;
};
export const selectUsers = ({ MainReducer }) => {
    return MainReducer.users;
};
export const selectAllPermissions = ({ SecurityConfig_reducer }) => {
    return SecurityConfig_reducer.permissions;
};
export const selectCurrUsers = createSelector(
    [selectUsers, selectCurrentTab],
    (users = false, currentLevel = false) => {
        if (users && currentLevel) {
            return _.compact(
                Object.keys(users).map((e) => {
                    if (users[e].profile.access_level === currentLevel) {
                        return (
                            users[e].profile.first_name +
                            " " +
                            users[e].profile.last_name
                        );
                    }
                    return null;
                    
                })
            );
        } else {
            return false;
        }
    }
);
export const selectPermissions = createSelector(
    [selectAllPermissions, selectCurrentTab],
    (permissions = false, currentLevel = false) => {
        if (permissions && currentLevel) {
            //permissions[currentLevel];
            return permissions[currentLevel]
                ? Object.keys(permissions[currentLevel])
                      .map((e) => permissions[currentLevel][e])
                      .sort((x, y) => {
                          return x.top === y.top ? 0 : x.top ? -1 : 1;
                      })
                : false;
        } else {
            return false;
        }
    }
);
// return Object.keys(permissions[currentLevel]).sort((x, y) => {
//     return x.priority === y.priority ? 0 : x.priority ? -1 : 1;
// });
